import React from "react";
import { get, isEmpty } from "lodash";
import { Divider } from "@mui/material";
import InvoicePeriod from "./InvoicePeriod";
import utils from "../utils/index";
import "./Invoice.css";

const InvoiceDetail = (props) => {
    const { invoice } = props;

    if (get(invoice, "summary") && !isEmpty(get(invoice, "periods", null))) {
        return (
            <div className="TableSuperHeaderContainer">
                <div className="invoiceHeaderText">
                    <div>
                        <span className="preTableHeader">Calculated Total Consideration (Reference Only)</span>
                        <br />
                        <span className="preTableHeaderSub">
                            {invoice["summary"].totalMonths} months / {invoice["summary"].freeMonths} months free /{" "}
                            {invoice["summary"].discountedMonths} months discounted
                            {invoice["summary"].preTermMonths + invoice["summary"].postTermMonths > 0
                                ? ", " +
                                  (invoice["summary"].preTermMonths + invoice["summary"].postTermMonths) +
                                  " months free outside term"
                                : ""}
                        </span>
                    </div>
                    <div>
                        <span className="preTableHeaderValue">
                            {utils.operations.toDollarAmount(invoice["summary"].totalAmount)} Total
                        </span>
                    </div>
                </div>

                <Divider />
                {invoice &&
                    invoice["periods"] &&
                    Object.keys(invoice["periods"]).map((period, i) => (
                        <InvoicePeriod period={invoice["periods"][period]} key={i} {...props} />
                    ))}
            </div>
        );
    } else {
        return null;
    }
};

export default InvoiceDetail;
